import { useEffect, useRef } from 'react';
import { createReconnectingSocket } from '../../../../shared/sockets';
import { buildInterveneStatusSocketUrl } from '../urls/buildInterveneSocketUrls';

export function useInterveneStatusSocket({
  botNumber,
  phoneNumber,
  onPayload,
  onStatusChange,
}) {
  const onPayloadRef = useRef(onPayload);
  onPayloadRef.current = onPayload;

  useEffect(() => {
    const url = buildInterveneStatusSocketUrl(botNumber, phoneNumber);
    if (!url) {
      onStatusChange?.('Disconnected');
      return undefined;
    }

    const socket = createReconnectingSocket(url);
    const unsubStatus = socket.on('status', (status) => {
      onStatusChange?.(status);
    });
    const unsubMessage = socket.on('message', (payload) => {
      onPayloadRef.current?.(payload);
    });

    return () => {
      unsubStatus();
      unsubMessage();
      socket.disconnect();
    };
  }, [botNumber, phoneNumber, onStatusChange]);
}
